export default "__VITE_ASSET__BjUReJB___"